import Vue from 'vue';
let $message

let service_url = process.env.NODE_ENV === 'development' ? '/gdQss' : 'http://127.0.0.1:10012'
/**
 * 解密
 * @param {string} KeyId  密钥
 * @param {string} Data 密文
 **/
function decrypt(KeyId, Data) {
	$message = Vue.prototype.$message({
		message: '量子解密中...',
		iconClass: 'el-icon-loading',
		duration: 0
	});
	return new Promise((resolve, reject) => {
		//解密
		doPost('/DecryptData/Request', {
			KeyId,
			Data
		}).then(res => {
			$message.close()
			if (res.Code == 655361 || res.Code == 655365) {
				//重新初始化
				InitQuantum()
				notify('失败', '解密失败:' + res.Code, 'warning')
			} else if (res.Code == 0) {
				let data = 'data:image/jpg;base64,' + res.Data
				resolve(data)
			} else {
				notify('失败', res.Message, 'warning')
			}

		}).catch(err => {
			console.log(err);
			$message.close()
			notify('失败', '解密失败:' + err.status, 'warning')
			reject(err)
		})
	})
}
//初始化
function InitQuantum() {
	return new Promise((resolve, reject) => {
		doGet('/InitQuantum', {}).then(res => {
			// notify('成功', '初始化量子成功', 'success')
			resolve(res)
		}).catch(err => {
			notify('失败', '初始化量子失败:' + err.status, 'warning')
			reject(err)
		})
	})

}

function resolveLocalFileSystemURL(tempFilePath) {
	return new Promise((resolve, reject) => {
		let xhr = new XMLHttpRequest();
		xhr.open("get", tempFilePath, true);
		xhr.responseType = "blob";
		xhr.onload = function (data) {
			if (this.status == 200) {
				const reader = new FileReader()
				reader.onload = function () {
					resolve(reader.result)
				}
				reader.readAsText(this.response);
			} else {
				reject()
			}
		};
		xhr.send();
	})

}


async function doPost(url, req, successCallback, errCallback) {
	return new Promise((resolve, reject) => {
		Vue.http.post(service_url + url, req, {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8'
			}
		}).then(function (response) {
			successCallback && successCallback(response.data);
			resolve(response.data)
		}, function (error) {
			errCallback && errCallback(error)
			reject(error)
		});
	})

}
async function doGet(url, req, successCallback, errCallback) {
	return new Promise((resolt, rejcet) => {
		// let xhr = new XMLHttpRequest();
		// xhr.open("get", service_url + url, true);
		// xhr.onload = function(data) {
		// 	if (this.status == 200) {
		// 		successCallback && successCallback(this.response);
		// 		resolt(this.response)
		// 	} else {
		// 		errCallback && errCallback()
		// 		rejcet()
		// 	}
		// };
		// xhr.send();
		Vue.http.get(service_url + url, {
			params: req
		}, {
			emulateJSON: true, //允许跨越
		}).then(function (response) {
			successCallback && successCallback(response.data);
			resolt(response.data)
		}, function (error) {
			errCallback && errCallback(error)
			rejcet(error)
		});
	})

}

function notify(title, message, type) {
	Vue.prototype.$notify({
		title,
		message,
		type
	});
}
export default {
	decrypt,
	InitQuantum,
	resolveLocalFileSystemURL
}



// WEBPACK FOOTER //
// ./static/js/function/gdQSS.js